var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHomeFeature3(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.867 51L36 44.5l2.475-2.513 3.392 3.445 7.658-7.779L52 40.708 41.867 51zm-8.96 0h-16.64C13.899 51 12 49.072 12 46.667V16.333C12 13.928 13.899 12 16.267 12h29.866c2.368 0 4.267 1.928 4.267 4.333v16.9a12.642 12.642 0 00-4.267-1.56v-15.34H16.267v30.334H31.37c.256 1.56.789 3.011 1.536 4.333zM31.2 42.333H20.533V38H31.2v4.333zm5.717-8.666H20.533v-4.334h21.334v2.34a12.458 12.458 0 00-4.95 1.994zM41.867 25H20.533v-4.333h21.334",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15 44H9.333A4.318 4.318 0 015 39.667V9.333A4.318 4.318 0 019.333 5h30.334A4.318 4.318 0 0144 9.333V15.5a12.967 12.967 0 00-4.333-1.56V9.333H9.333v30.334h4.107c.26 1.56.802 3.011 1.56 4.333z",
    fill: "#fff"
  })));
}
export default SvgHomeFeature3;